import { WorkspaceRoleSchema } from "../workspace";
import { z } from "zod";
export const ForgeProjectRole = z.enum(["Viewer", "Builder", "Admin"]);
export const ForgeDefaultProjectRole = ForgeProjectRole.exclude(["Admin"]);
export const ForgeProjectMembership = z.object({
    userId: z.string(),
    forgeProjectId: z.string(),
    workspaceMembershipId: z.string(),
    workspaceRole: WorkspaceRoleSchema,
    role: ForgeProjectRole,
});
